import { TableCsvLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useExportAsCsv } from '@/hooks'
import { ExportItem } from '../ExportItem'

interface Props {
  exportable: boolean
}

export const ExportCsv: React.FC<Props> = ({ exportable }) => {
  const onClick = useExportAsCsv(true)

  return (
    <ExportItem
      label="CSV"
      exportable={exportable}
      icon={TableCsvLight}
      onClick={onClick}
    />
  )
}
